import { EVENT_BUS } from '@/model/event-bus';
import { getCurrentSceneName } from '@/scenes';

export const VIRTUAL_KEYBOARD_SYMBOLS = [
    '↹', '1', 'q', '2', 'w', 'e', '4', 'r', '5', 't', '6', 'y',
    'u', '8', 'i', '9', 'o', 'p', 'a', 'z', 's', 'x', 'd', 'c',
    'v', 'g', 'b', 'h', 'n', 'm', 'k', ',', 'l', '.', ';', '/',
    '⇧'
];

export const VIRTUAL_KEYBOARD_CODES = [
    'Tab', 'Digit1', 'KeyQ', 'Digit2', 'KeyW', 'KeyE', 'Digit4', 'KeyR', 'Digit5', 'KeyT', 'Digit6', 'KeyY',
    'KeyU', 'Digit8', 'KeyI', 'Digit9', 'KeyO', 'KeyP', 'KeyA', 'KeyZ', 'KeyS', 'KeyX', 'KeyD', 'KeyC',
    'KeyV', 'KeyG', 'KeyB', 'KeyH', 'KeyN', 'KeyM', 'KeyK', 'Comma', 'KeyL', 'Period', 'Semicolon', 'Slash',
    'ShiftRight'
];

export function initKeyboardControls() {
    document.addEventListener('keyup', (e) => {
        e.preventDefault();
        e.stopPropagation();
        switch (e.code) {
            case 'ArrowUp': EVENT_BUS.emit('MENU_UP', getCurrentSceneName()); break;
            case 'ArrowDown': EVENT_BUS.emit('MENU_DOWN', getCurrentSceneName()); break;
            case 'Enter': EVENT_BUS.emit('MENU_ENTER', getCurrentSceneName()); break;
            case 'Escape': {
                e.preventDefault();
                e.stopImmediatePropagation();
                EVENT_BUS.emit('MENU_ESC', getCurrentSceneName());
            } break;
        }
    });

    document.addEventListener('keydown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        switch (e.code) {
            case 'ArrowUp': EVENT_BUS.emit('MENU_SCROLL_DOWN', getCurrentSceneName()); break;
            case 'ArrowDown': EVENT_BUS.emit('MENU_SCROLL_UP', getCurrentSceneName()); break;
        }
    });

    document.addEventListener('wheel', (e) => {
        if (e.wheelDeltaY > 0) {
            EVENT_BUS.emit('MENU_SCROLL_UP', getCurrentSceneName());
        } else {
            EVENT_BUS.emit('MENU_SCROLL_DOWN', getCurrentSceneName());
        }
    });
}

export function initVirtualKeyboard() {
    document.addEventListener('keyup', (e) => {
        if (VIRTUAL_KEYBOARD_CODES.includes(e.code)) {
            e.preventDefault();
            EVENT_BUS.emit('MIDI_noteOff', {
                pianoNote: 28 + VIRTUAL_KEYBOARD_CODES.indexOf(e.code)
            });
        }
    });

    document.addEventListener('keydown', (e) => {
        if (VIRTUAL_KEYBOARD_CODES.includes(e.code)) {
            e.preventDefault();
            EVENT_BUS.emit('MIDI_noteOn', {
                pianoNote: 28 + VIRTUAL_KEYBOARD_CODES.indexOf(e.code)
            });
        }
    });
}
